import {
  CALC_LIST_REQUEST,
  CALC_LIST_SUCCESS,
  CALC_LIST_FAIL,
} from "../constants/calcConstants";

export const calcListReducer = (state = { calcs: [] }, action) => {
  switch (action.type) {
    case CALC_LIST_REQUEST:
      return { loading: true, calcs: [] };
    case CALC_LIST_SUCCESS:
      return { loading: false, calcs: action.payload };
    case CALC_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
